import React from 'react';
import './AboutUs.css';
import PageHero from './PageHero';

const AboutUs: React.FC = () => {
  return (
    <div className="about-us-page">
      <PageHero 
        title="About Us"
        subtitle="Your Gateway to Island Living"
      />
      <div className="about-container">
        <div className="about-content">
          <section className="about-section">
            <h2>Our Story</h2>
            <p>
            Southern Comfort Camps (SoCoCamps) comes from over 30 years of living and working on the Houtman Abrolhos. 
            We started here in the rock lobster industry, spending months of each year on the islands before eventually 
            transitioning that local knowledge into eco-tourism.
            We’re 100% family owned and operated with backgrounds in the professional fishing, maritime and marine science industries. 
            We built these camps because we wanted to provide a way for people to experience the islands the way we do - 
            authentically and safely.

            </p>
            <p>
              Our camps are designed to provide comfort while maintaining respect for 
              the environment. We offer sustainable, eco-friendly accommodation that allow 
              you to immerse yourself in the islands' natural wonders without compromising 
              on comfort or safety.
            </p>
          </section>

          <section className="about-section">
            <h2>The Setup</h2>
            <p>
            Remote, low-impact, and functional. The Abrolhos is a unique environment that requires a specific approach. 
            We’ve designed our camps to be self-sufficient and low-impact, sustainable systems to keep things running. 
            Our goal is to provide a comfortable base for exploration without over-complicating the experience or messing with the local ecosystem.
            </p>
          </section>

          <section className="about-section">
            <h2>Our Values</h2>
            <div className="values-list">
              <div className="value-item">
                <h3>Environmental Stewardship</h3>
                <p>With professional ties to both the fishing industry and marine biology, we take a practical approach to conservation. 
                  We operate with a "tread lightly" mindset to ensure the reefs and island habitats remain healthy for the long term.</p>
              </div>
              <div className="value-item">
                <h3>Local Knowledge</h3>
                <p>We’ve spent decades navigating these reefs and working alongside the island community. 
                  That history is built into everything we do, from how we choose our day to day operations to the advice we give our guests.</p>
              </div>
              <div className="value-item">
                <h3>Education</h3>
                <p>We believe in educating our guests about the islands' unique ecology, history, and the importance of conservation. Just ask us!</p>
              </div>
              <div className="value-item">
                <h3>Exceptional Experiences</h3>
                <p>We've spent decades getting to enjoy everything the Abrolhos has to offer. We hope to share the joy with you.</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>Contact Us</h2>
            <div className="contact-info">
              <p><strong>Email:</strong> info@southerncomfortcamps.com</p>
              <p><strong>Phone:</strong> (+61) 0439 690 119</p>
              <p><strong>Location:</strong> Abrolhos Islands, Western Australia</p>
            </div>
            <p className="contact-note">
              Have questions about your stay or need assistance? We're here to help! 
              Reach out to us and we'll be happy to assist you with your Abrolhos Islands adventure at Southern Comfort Camps.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;

